import React from 'react';
import ModuleDetailPage from './ModuleDetailPage';

const QRMenuPage = () => <ModuleDetailPage moduleId="qr-menu" />;

export default QRMenuPage;
